export default __webpack_public_path__ + "static/media/qr.ac100773.svg";